export default __webpack_public_path__ + "static/media/info.c9eb7904.svg";